import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PrintMediaBarcodesComponent } from "./print-media-barcodes/print-media-barcodes.component";
import { PrintReaderBarcodesComponent } from "./print-reader-barcodes/print-reader-barcodes.component";
import { PrintMediaSignaturesComponent } from "./print-media-signatures/print-media-signatures.component";
import { PrintReaderIdComponent } from "./print-reader-id/print-reader-id.component";

const routes: Routes = [
  { path: "media/:val", component: PrintMediaBarcodesComponent },
  { path: "signature/:val", component: PrintMediaSignaturesComponent },
  {
    path: "reader/:val",
    component: PrintReaderBarcodesComponent,
  },
  {
    path: "reader-id/:val",
    component: PrintReaderIdComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrintRoutingModule {}
